import { getValuesMap, swapKeysAndValues } from "@helpers/common";

export const maxImagesCount = 40;
export const defaultMaxFilesCount = 40;
export const MAX_VIDEO_SIZE = 3 * 1000 * 1000 * 1000; // 3GB in bytes
export const MAX_AUDIO_SIZE = 200 * 1000 * 1000; // 200MB in bytes
export const MAX_IMAGE_SIZE = { width: 6000, height: 6000 };

export const polygonLink = "https://polygonscan.com/";
export const polygonGuide =
  "https://docs.polygon.technology/docs/develop/metamask/config-polygon-on-metamask/#add-the-polygon-network-manually";

const postAccessTypes = {
  1: "freeEveryone",
  2: "freeFollowers",
  3: "paid",
};

export const postContentTypes = {
  1: "text",
  2: "image",
  3: "video",
  4: "audio",
};

const postTypes = {
  1: "device",
  2: "socialNetwork",
  3: "challenge",
  4: "contentProposal",
  5: "stream",
};

export const postsTabsType = {
  published: 0,
  scheduled: 1,
};

export const livestreamsTabsType = {
  past: 0,
  scheduled: 1,
};

export const postAccess = swapKeysAndValues(postAccessTypes);
export const postType = swapKeysAndValues(postTypes);
export const postContentTypeMap = getValuesMap(postContentTypes);

export const createPostOptions = [
  {
    value: postAccess.freeEveryone,
    label: "FREE_FOR_EVERYONE",
    comment: "FREE_FOR_EVERYONE_DESCRIPTION",
  },
  {
    value: postAccess.freeFollowers,
    label: "FREE_FOR_FOLLOWERS",
    comment: "FREE_FOR_FOLLOWERS_DESCRIPTION",
  },
  {
    value: postAccess.paid,
    label: "PAID",
    comment: "PAID_DESCRIPTION",
  },
];

export const defaultCurrencyIndex = 0;

export const currencyList = [
  { label: "USD", value: "1" },
  { label: "PASSION", value: "2" },
];

export const currencyLabels = {
  1: "USD",
  2: "MATIC",
};

export const usdId = "1";
export const maticId = "2";

export const currencyExchange = {
  [maticId]: "USD",
  [usdId]: "PASSION",
};

export const hashPosts = "#posts";
export const hashSubscriptions = "#subs";
export const hashScheduledPosts = "#scheduled";
export const hashStreams = "#streams";
export const hashScheduledStreams = "#scheduledStreams";
export const hashPastStreams = "#pastStream";

export const postsMobileNavigation = [
  { key: postsTabsType.published, value: "PUBLISHED_POSTS" },
  { key: postsTabsType.scheduled, value: "SCHEDULED_POSTS" },
];

export const livestreamsMobileNavigation = [
  { key: livestreamsTabsType.past, value: "PAST_STREAMS" },
  { key: livestreamsTabsType.scheduled, value: "SCHEDULED_STREAMS" },
];
